module.exports = __webpack_public_path__ + "media/basic-details/conference@2x-134ce03c.png";